module.exports = __webpack_public_path__ + "img/Feature.ab01baf7.jpg";